export const TABS = {
  MESSAGES: 'messages',
  AI: 'ai'
} as const 